<div class="backdrop-box-details booking-travler-pop flight-booking-first-pop" *ngIf="showFirstPop">
  <div class="modal fade show traveler-popup-div" bsModal tabindex="-1" role="dialog"
    aria-labelledby="dialog-nested-name1" style="display: block">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="dialog-nested-name1" class="modal-title pull-left flight-detail-pop-title">
            <i class="fa-solid fa-plane"></i>
            {{ "Your Trip Detail" | translate }}
          </h4>
          <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="hideFlightBookingDetail()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
          </button>
        </div>
        <div class="modal-body flight-trip-in-body">
          <div class="row">
            <div class="col-lg-6">
              <!-- one-way summary -->
              <div class="flight-booking-ticket-ing one-way-flight-result-data" *ngIf="searchRequestType == 'one-way'">
                <div class="next-trip-ticket">
                  <div class="flight-city-dtls d-flex align-items-center justify-content-center mb-3 px-4">
                    <div class="from-city-name-ticket">
                      <h4>{{ oneWaySummary?.fromAirport.code }}</h4>
                      <span>{{ oneWaySummary?.fromAirport.city_name }},
                        {{ oneWaySummary?.fromAirport.country_name }}</span>
                    </div>
                    <div class="airline-icon-dcs">
                      <div class="flight-major-dtls">
                        <h6>
                          <p>
                            {{ oneWaySummary?.departureDate | date : "dd" }}
                            {{ (oneWaySummary?.departureDate | date : "MMM") ?? 'MMM' | translate }}
                            {{ oneWaySummary?.departureDate | date : "yyyy"}}
                          </p>
                        </h6>
                      </div>
                      <div class="arrow"></div>
                      <span>
                        <img src="/assets/image/flight-going.png" width="22" alt="">
                      </span>
                      <h6>{{ "One way" | translate }}</h6>
                    </div>
                    <div class="to-city-name-ticket">
                      <h4>{{ oneWaySummary?.toAirport.code }}</h4>
                      <span>{{ oneWaySummary?.toAirport.city_name }},
                        {{ oneWaySummary?.toAirport.country_name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- round-trip summary -->
              <div class="flight-booking-ticket-ing round-trip-flight-result-data"
                *ngIf="searchRequestType == 'round-trip'">
                <div class="next-trip-ticket">
                  <div class="flight-city-dtls d-flex align-items-center justify-content-center mb-3 px-4">
                    <div class="from-city-name-ticket">
                      <h4>{{ roundTripSummary.departureFlight.fromAirport.code }}</h4>
                      <span>{{ roundTripSummary.departureFlight.fromAirport.city_name }},
                        {{
                        roundTripSummary.departureFlight.fromAirport.country_name
                        }}</span>
                    </div>
                    <div class="airline-icon-dcs">
                      <div class="flight-major-dtls">
                        <p>
                          {{ roundTripSummary?.departureFlight.departureDate | date : "dd" }}
                          {{ (roundTripSummary?.departureFlight.departureDate | date : "MMM") ?? 'MMM' | translate }}
                          {{ roundTripSummary?.departureFlight.departureDate | date : "yyyy"}} <br />
                          {{ "Departure" | translate }}
                        </p>
                        <p>
                          {{ roundTripSummary?.returnFlight.returnDate | date : "dd" }}
                          {{ (roundTripSummary?.returnFlight.returnDate | date : "MMM") ?? 'MMM' | translate }}
                          {{ roundTripSummary?.returnFlight.returnDate | date : "yyyy"}} <br />
                          {{ "Return" | translate }}
                        </p>
                      </div>
                      <div class="arrow return-flight"></div>
                      <span>
                        <img src="/assets/image/round-trip.png" alt="" />
                      </span>
                    </div>
                    <div class="to-city-name-ticket">
                      <h4>{{ roundTripSummary.departureFlight.toAirport.code }}</h4>
                      <span>{{ roundTripSummary.departureFlight.toAirport.city_name }},
                        {{
                        roundTripSummary.departureFlight.toAirport.country_name
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- multi-city summary -->
              <div class="flight-booking-ticket-ing multi-trip-flight-result-data"
                *ngIf="searchRequestType == 'multi-city'">
                <div class="next-trip-ticket">
                  <div class="flight-city-dtls d-flex align-items-center justify-content-center mb-3 px-4">
                    <div class="from-city-name-ticket">
                      <h4>{{ multiCitySummary.origins[0].originCode }}</h4>
                      <span>{{ multiCitySummary.origins[0].originData.city_name }},
                        {{
                        multiCitySummary.origins[0].originData.country_name
                        }}</span>
                    </div>
                    <div class="airline-icon-dcs">
                      <div class="flight-major-dtls multicity-via-dtls">
                        <h6>
                          Via
                          <p> <mark *ngFor="let point of multiCitySummary.points">{{point.city_name}},</mark> </p>
                        </h6>
                      </div>
                      <div class="arrow"></div>
                      <span>
                        <img src="/assets/image/round-trip.png" alt="" />
                      </span>
                    </div>
                    <div class="to-city-name-ticket">
                      <h4>{{ multiCitySummary.origins[multiCitySummary.origins.length - 1].destinationCode }}</h4>
                      <span>{{ multiCitySummary.origins[multiCitySummary.origins.length - 1].destinationData.city_name
                        }},
                        {{
                        multiCitySummary.origins[multiCitySummary.origins.length - 1].destinationData.country_name
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- flight summary -->
              <div class="flight-booking-ticket-ing">
                <div class="next-trip-ticket">
                  <div class="ticket-number-dtls pt-0">
                    <div class="tick-book-dtls">
                      <p *ngIf="!selectedFlight.refundable">
                        <img src="/assets/image/filter/not-refundable.png" alt="" />

                        {{"Not" | translate}} {{"Refundable" | translate}}
                      </p>
                    </div>
                    <div class="tick-book-dtls">
                      <!-- if price including bages-->
                      <p *ngIf="selectedFlight.priceIncludedBags">
                        <img src="/assets/image/filter/chargeble-fees.png" alt="" />
                        {{"Changeable with fees" | translate}}
                        <!-- if price not including bages-->
                      </p>
                      <p *ngIf="!selectedFlight.priceIncludedBags">
                        <img src="/assets/image/filter/chargeble-fees.png" alt="" />
                        {{"Changeable with extra fees" | translate}}
                      </p>
                    </div>
                  </div>
                  <div class="booking-update position-relative">
                    <div class="booking-status-brdr"></div>
                  </div>
                  <div class="flight-detail" *ngFor="let flight of selectedFlight.flights; index as fi">
                    <!-- flight detail -->
                    <div class="trip-depart-arrival border-0">
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center mt-1 airline-class-number w-100">
                          <div class="flight-from-to-name-dtls">
                            <h5> <i class="fa-solid fa-plane"></i> {{ flight.departureAirportData.city_name }} - {{
                              flight.arrivalAirportData.city_name }}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--flight segment detail-->
                    <div class="trip-depart-arrival border-0" *ngFor="let segment of flight.segments; index as i">
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center mt-1 airline-class-number w-100">
                          <div class="flight-from-to-name-dtls">
                            <h5> {{segment.departureAirportData.city_name}} - {{segment.arrivalAirportData.city_name}}
                            </h5>
                          </div>
                          <div>
                            <img class="me-2" src="{{ segment.airlineData.logo }}" width="30" height="30"
                              alt="dummy-airline" />
                            <p class="mb-0">
                              {{ segment.airlineData.name }} {{segment.airlineData.code}}-{{segment.number}} <br />
                              {{segment.aircraftData?.name}}
                            </p>
                          </div>
                        </div>
                        <div class="departure-luggage pt-1">
                          <h5>{{ "Departure" | translate }} - {{ segment.departureDate| date : "shortTime"}}</h5>
                          <span>{{segment.departureAirportData.airport_name}} ({{ segment.departure.iataCode }})
                          </span>
                          <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                          <p><span>{{ segment.departureDate| date : "fullDate"}}</span></p>
                          <p>
                            {{"Luggage" | translate}}:
                            <span *ngIf="segment.segmentFare.bagUnit!=undefined">
                              {{segment.segmentFare?.bagUnit}}
                              {{"Piece(s)" | translate}}
                            </span>
                            <span *ngIf="segment.segmentFare.bagWeight != undefined">
                              {{segment.segmentFare?.bagWeight}}
                              {{segment.segmentFare?.bagWeightUnit}}
                            </span>
                          </p>
                          <p>{{"Cabin bag" | translate}}: 7KG</p>
                        </div>
                        <div class="arrival-class pt-1">
                          <h5>{{ "Arrival" | translate }} - {{ segment.arrivalDate| date : "shortTime"}}</h5>
                          <span>
                            {{segment.arrivalAirportData.airport_name}} ({{ segment.arrival.iataCode }})</span>
                          <!-- <p>Cairo, Egypt</p> -->
                          <p><span>{{ segment.arrivalDate| date : "fullDate"}}</span></p>
                          <p><span>Trip Class : </span> {{ segment.segmentFare?.cabin.split('_').join(' ') | translate
                            }}</p>
                        </div>
                      </div>
                      <div class="layovertime-final-flight my-0"
                        *ngIf="flight.segments.length > 1 && flight.segments.length - 1 != i">
                        <div *ngFor="let layover of layoverData">
                          <div class="layour-city-name"
                            *ngIf="layover.toSegmentId == flight.segments[flight.segments.length - 1].id">
                            <span>
                              {{"Layover duration" | translate}}
                              {{ layover.layoverDurationText }}
                            </span>
                          </div>
                        </div>
                        <div *ngIf="segment.numberOfStops > 0">
                          <div class="layour-city-name" *ngFor="let stop of segment.stops">
                            <p>{{ stop.description }}</p>
                            <p>{{ stop.duration }}</p>
                            <p>
                              {{ stop.arrivalAt | date : "dd MMM yyyy" }}
                            </p>
                            <p>
                              {{ stop.departureAt | date : "dd MMM yyyy" }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="booking-update position-relative return-flight-sepration"
                      *ngIf="fi >= 0 && fi < selectedFlight.flights.length - 1">
                      <div class="booking-status-brdr"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flight-booking-ticket-ing one-way-flight-result-data dsp-none">
                <div class="next-trip-ticket">
                  <div class="flight-city-dtls d-flex align-items-center justify-content-center mb-3 px-4">
                    <div class="from-city-name-ticket">
                      <h4>{{ "AHM" | translate }}</h4>
                      <span>{{ "Ahmedabad, India" | translate }}</span>
                      <span>{{ "April 23, 2023" | translate }}</span>
                    </div>
                    <div class="airline-icon-dcs">
                      <div class="flight-major-dtls">
                        <p>{{ "2H 15M" | translate }}</p>
                        <p>{{ "1 Stop" | translate }}</p>
                      </div>
                      <div class="arrow"></div>
                      <span>
                        <img src="/assets/image/flight-going.png" width="22" alt="">
                      </span>
                      <h6>{{ "One way" | translate }}</h6>
                    </div>
                    <div class="to-city-name-ticket">
                      <h4>{{ "Sin" | translate }}</h4>
                      <span>{{ "Singapore, Changi" | translate }}</span>
                      <span>{{ "April 24, 2023" | translate }}</span>
                    </div>
                  </div>
                  <div class="booking-update position-relative">
                    <div class="booking-status-brdr"></div>
                  </div>
                  <div class="ticket-number-dtls">
                    <div class="tick-book-dtls">
                      <p>
                        <img src="/assets/image/filter/not-refundable.png" alt="" />{{ "Refundable with fees" |
                        translate }}
                      </p>
                    </div>
                    <div class="tick-book-dtls">
                      <p>
                        <img src="/assets/image/filter/chargeble-fees.png" alt="" />{{ "Chargeable with fees" |
                        translate }}
                      </p>
                    </div>
                  </div>
                  <div class="booking-update position-relative">
                    <div class="booking-status-brdr"></div>
                  </div>
                  <div class="trip-depart-arrival border-0">
                    <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                      <div class="airline-name d-flex align-items-center mt-1 airline-class-number w-100">
                        <div class="flight-from-to-name-dtls">
                          <h5>Ahmedabad - Mumbai</h5>
                        </div>
                        <div>
                          <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                            alt="dummy-airline" />
                          <p class="mb-0">
                            Egyptair MS-2633 <br />
                            BOEING - 737
                          </p>
                        </div>
                      </div>
                      <div class="departure-luggage pt-1">
                        <h5>{{ "Departure" | translate }} - 08:35 Pm</h5>
                        <span>Ahmedabad, Airport</span>
                        <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                        <p><span>Saturday April 23, 2023</span></p>
                        <p><span>Luggage : </span>23 kg. x2</p>
                        <p><span>Cabin Bag :</span>7 Kg</p>
                      </div>
                      <div class="arrival-class pt-1">
                        <h5>{{ "Arrival" | translate }} - 10:20 Pm</h5>
                        <span>Mumbai, Airport</span>
                        <!-- <p>Cairo, Egypt</p> -->
                        <p><span>Saturday April 23, 2023</span></p>
                        <p><span>Trip Class : </span> Economy</p>
                      </div>
                    </div>
                    <div class="layovertime-final-flight">
                      <span>Layover : 6h 20m</span>
                    </div>
                    <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                      <div class="airline-name d-flex align-items-center airline-class-number w-100" pt-0>
                        <div class="flight-from-to-name-dtls">
                          <h5>Mumbai - Singapore</h5>
                        </div>
                        <div>
                          <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                            alt="dummy-airline" />
                          <p>
                            Egyptair MS-2633 <br />
                            BOEING - 737
                          </p>
                        </div>
                      </div>
                      <div class="departure-luggage pt-1">
                        <h5>{{ "Departure" | translate }} (BOM) - 2:35 Am</h5>
                        <span>Mumbai, Airport</span>
                        <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                        <p><span>Saturday April 24, 2023</span></p>
                        <p><span>Luggage : </span>23 kg. x2</p>
                        <p><span>Cabin Bag :</span>7 Kg</p>
                      </div>
                      <div class="arrival-class pt-1">
                        <h5>{{ "Arrival" | translate }} (SIN) - 8:20 Am</h5>
                        <span>Changi, Singapore</span>
                        <!-- <p>Cairo, Egypt</p> -->
                        <p><span>Sunday April 24, 2023</span></p>
                        <p><span>Trip Class : </span> Economy</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <!-- round trip booking details -->
              <div class="flight-booking-ticket-ing round-trip-flight-result-data dsp-none">
                <div class="next-trip-ticket">
                  <div class="flight-city-dtls d-flex align-items-center justify-content-center mb-3 px-4">
                    <div class="from-city-name-ticket">
                      <h4>{{ "AHM" | translate }}</h4>
                      <span>{{ "Ahmedabad, India" | translate }}</span>
                      <span>{{ "April 23, 2023" | translate }}</span>
                    </div>
                    <div class="airline-icon-dcs">
                      <div class="flight-major-dtls">
                        <p>
                          22 Dec 2023 <br />
                          {{ "Departure" | translate }}
                        </p>
                        <p>
                          25 Dec 2023 <br />
                          {{ "Return" | translate }}
                        </p>
                      </div>
                      <div class="arrow return-flight"></div>
                      <span>
                        <img src="/assets/image/round-trip.png" alt="" />
                      </span>
                    </div>
                    <div class="to-city-name-ticket">
                      <h4>{{ "Sin" | translate }}</h4>
                      <span>{{ "Singapore, Changi" | translate }}</span>
                      <span>{{ "April 24, 2023" | translate }}</span>
                    </div>
                  </div>

                  <!-- refundable charges common part -->
                  <div class="booking-update position-relative">
                    <div class="booking-status-brdr"></div>
                  </div>
                  <div class="ticket-number-dtls">
                    <div class="tick-book-dtls">
                      <p>
                        <img src="/assets/image/filter/not-refundable.png" alt="" />{{ "Refundable with fees" |
                        translate }}
                      </p>
                    </div>
                    <div class="tick-book-dtls">
                      <p>
                        <img src="/assets/image/filter/chargeble-fees.png" alt="" />{{ "Chargeable with fees" |
                        translate }}
                      </p>
                    </div>
                  </div>
                  <div class="booking-update position-relative">
                    <div class="booking-status-brdr"></div>
                  </div>

                  <!-- departure flight details -->
                  <div class="flight-ongoing-details">
                    <div class="trip-depart-arrival border-0">
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center mt-1 airline-class-number w-100">
                          <div class="flight-from-to-name-dtls going-flight-ico">
                            <h5>Ahmedabad - Mumbai</h5>
                          </div>
                          <div>
                            <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                              alt="dummy-airline" />
                            <p class="mb-0">
                              Egyptair MS-2633 <br />
                              BOEING - 737
                            </p>
                          </div>
                        </div>
                        <div class="departure-luggage pt-1">
                          <h5>{{ "Departure" | translate }} - 08:35 Pm</h5>
                          <span>Ahmedabad, Airport</span>
                          <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                          <p><span>Saturday April 23, 2023</span></p>
                          <p><span>Luggage : </span>23 kg. x2</p>
                          <p><span>Cabin Bag :</span>7 Kg</p>
                        </div>
                        <div class="arrival-class pt-1">
                          <h5>{{ "Arrival" | translate }} - 10:20 Pm</h5>
                          <span>Mumbai, Airport</span>
                          <!-- <p>Cairo, Egypt</p> -->
                          <p><span>Saturday April 23, 2023</span></p>
                          <p><span>Trip Class : </span> Economy</p>
                        </div>
                      </div>
                      <div class="layovertime-final-flight">
                        <span>Layover : 6h 20m</span>
                      </div>
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center airline-class-number w-100" pt-0>
                          <div class="flight-from-to-name-dtls going-flight-ico">
                            <h5> Mumbai - Singapore</h5>
                          </div>
                          <div>
                            <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                              alt="dummy-airline" />
                            <p>
                              Egyptair MS-2633 <br />
                              BOEING - 737
                            </p>
                          </div>
                        </div>
                        <div class="departure-luggage pt-1">
                          <h5>{{ "Departure" | translate }} (BOM) - 2:35 Am</h5>
                          <span>Mumbai, Airport</span>
                          <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                          <p><span>Saturday April 24, 2023</span></p>
                          <p><span>Luggage : </span>23 kg. x2</p>
                          <p><span>Cabin Bag :</span>7 Kg</p>
                        </div>
                        <div class="arrival-class pt-1">
                          <h5>{{ "Arrival" | translate }} (SIN) - 8:20 Am</h5>
                          <span>Changi, Singapore</span>
                          <!-- <p>Cairo, Egypt</p> -->
                          <p>Sunday <span>April 24, 2023</span></p>
                          <p><span>Trip Class : </span> Economy</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="booking-update position-relative return-flight-sepration">
                    <div class="booking-status-brdr"></div>
                  </div>

                  <!-- return flight code -->
                  <div class="flight-ongoing-details">
                    <div class="trip-depart-arrival border-0">
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center mt-1 airline-class-number w-100">
                          <div class="flight-from-to-name-dtls returing-back-flight">
                            <h5>Singapore - Mumbai</h5>
                          </div>
                          <div>
                            <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                              alt="dummy-airline" />
                            <p class="mb-0">
                              Egyptair MS-2633 <br />
                              BOEING - 737
                            </p>
                          </div>
                        </div>
                        <div class="departure-luggage pt-1">
                          <h5>{{ "Departure" | translate }} - 08:35 Pm</h5>
                          <span>Ahmedabad, Airport</span>
                          <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                          <p>Saturday <span>April 23, 2023</span></p>
                          <p><span>Luggage : </span>23 kg. x2</p>
                          <p><span>Cabin Bag :</span>7 Kg</p>
                        </div>
                        <div class="arrival-class pt-1">
                          <h5>{{ "Arrival" | translate }} - 10:20 Pm</h5>
                          <span>Mumbai, Airport</span>
                          <!-- <p>Cairo, Egypt</p> -->
                          <p>Saturday <span>April 23, 2023</span></p>
                          <p><span>Trip Class : </span> Economy</p>
                        </div>
                      </div>
                      <div class="layovertime-final-flight">
                        <span>Layover : 6h 20m</span>
                      </div>
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center airline-class-number w-100" pt-0>
                          <div class="flight-from-to-name-dtls returing-back-flight">
                            <h5>Mumbai - Ahmedabad</h5>
                          </div>
                          <div>
                            <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                              alt="dummy-airline" />
                            <p>
                              Egyptair MS-2633 <br />
                              BOEING - 737
                            </p>
                          </div>
                        </div>
                        <div class="departure-luggage pt-1">
                          <h5>{{ "Departure" | translate }} (BOM) - 2:35 Am</h5>
                          <span>Mumbai, Airport</span>
                          <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                          <p><span>Saturday April 24, 2023</span></p>
                          <p><span>Luggage : </span>23 kg. x2</p>
                          <p><span>Cabin Bag :</span>7 Kg</p>
                        </div>
                        <div class="arrival-class pt-1">
                          <h5>{{ "Arrival" | translate }} (SIN) - 8:20 Am</h5>
                          <span>Changi, Singapore</span>
                          <!-- <p>Cairo, Egypt</p> -->
                          <p>Sunday <span>April 24, 2023</span></p>
                          <p><span>Trip Class : </span> Economy</p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <!-- multi trip booking details -->
              <div class="flight-booking-ticket-ing multi-trip-flight-result-data dsp-none">
                <div class="next-trip-ticket">
                  <div class="flight-city-dtls d-flex align-items-center justify-content-center mb-3 px-4">
                    <div class="from-city-name-ticket">
                      <h4>{{ "AHM" | translate }}</h4>
                      <span>{{ "Ahmedabad, India" | translate }}</span>
                      <span>{{ "April 23, 2023" | translate }}</span>
                    </div>
                    <div class="airline-icon-dcs">
                      <div class="flight-major-dtls multicity-via-dtls">
                        <h6>
                          Via
                          <p>Ahmedabad, Mumbai</p>
                        </h6>
                      </div>
                      <div class="arrow"></div>
                      <span>
                        <img src="/assets/image/round-trip.png" alt="" />
                      </span>
                    </div>
                    <div class="to-city-name-ticket">
                      <h4>{{ "Sin" | translate }}</h4>
                      <span>{{ "Singapore, Changi" | translate }}</span>
                      <span>{{ "April 24, 2023" | translate }}</span>
                    </div>
                  </div>

                  <!-- refundable charges common part -->
                  <div class="booking-update position-relative">
                    <div class="booking-status-brdr"></div>
                  </div>
                  <div class="ticket-number-dtls">
                    <div class="tick-book-dtls">
                      <p>
                        <img src="/assets/image/filter/not-refundable.png" alt="" />{{ "Refundable with fees" |
                        translate }}
                      </p>
                    </div>
                    <div class="tick-book-dtls">
                      <p>
                        <img src="/assets/image/filter/chargeble-fees.png" alt="" />{{ "Chargeable with fees" |
                        translate }}
                      </p>
                    </div>
                  </div>
                  <div class="booking-update position-relative">
                    <div class="booking-status-brdr"></div>
                  </div>

                  <!-- departure flight details -->
                  <div class="flight-ongoing-details">
                    <div class="trip-depart-arrival border-0">
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center mt-1 airline-class-number w-100">
                          <div class="flight-from-to-name-dtls going-flight-ico">
                            <h5>Ahmedabad - Mumbai</h5>
                          </div>
                          <div>
                            <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                              alt="dummy-airline" />
                            <p class="mb-0">
                              Egyptair MS-2633 <br />
                              BOEING - 737
                            </p>
                          </div>
                        </div>
                        <div class="departure-luggage pt-1">
                          <h5>{{ "Departure" | translate }} - 08:35 Pm</h5>
                          <span>Ahmedabad, Airport</span>
                          <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                          <p><span>Saturday April 23, 2023</span></p>
                          <p><span>Luggage : </span>23 kg. x2</p>
                          <p><span>Cabin Bag :</span>7 Kg</p>
                        </div>
                        <div class="arrival-class pt-1">
                          <h5>{{ "Arrival" | translate }} - 10:20 Pm</h5>
                          <span>Mumbai, Airport</span>
                          <!-- <p>Cairo, Egypt</p> -->
                          <p><span>Saturday April 23, 2023</span></p>
                          <p><span>Trip Class : </span> Economy</p>
                        </div>
                      </div>
                      <div class="layovertime-final-flight">
                        <span>Layover : 6h 20m</span>
                      </div>
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center airline-class-number w-100" pt-0>
                          <div class="flight-from-to-name-dtls going-flight-ico">
                            <h5> Mumbai - Singapore</h5>
                          </div>
                          <div>
                            <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                              alt="dummy-airline" />
                            <p>
                              Egyptair MS-2633 <br />
                              BOEING - 737
                            </p>
                          </div>
                        </div>
                        <div class="departure-luggage pt-1">
                          <h5>{{ "Departure" | translate }} (BOM) - 2:35 Am</h5>
                          <span>Mumbai, Airport</span>
                          <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                          <p><span>Saturday April 24, 2023</span></p>
                          <p><span>Luggage : </span>23 kg. x2</p>
                          <p><span>Cabin Bag :</span>7 Kg</p>
                        </div>
                        <div class="arrival-class pt-1">
                          <h5>{{ "Arrival" | translate }} (SIN) - 8:20 Am</h5>
                          <span>Changi, Singapore</span>
                          <!-- <p>Cairo, Egypt</p> -->
                          <p>Sunday <span>April 24, 2023</span></p>
                          <p><span>Trip Class : </span> Economy</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="booking-update position-relative return-flight-sepration">
                    <div class="booking-status-brdr"></div>
                  </div>

                  <!-- return flight code -->
                  <div class="flight-ongoing-details">
                    <div class="trip-depart-arrival border-0">
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center mt-1 airline-class-number w-100">
                          <div class="flight-from-to-name-dtls returing-back-flight">
                            <h5>Singapore - Mumbai</h5>
                          </div>
                          <div>
                            <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                              alt="dummy-airline" />
                            <p class="mb-0">
                              Egyptair MS-2633 <br />
                              BOEING - 737
                            </p>
                          </div>
                        </div>
                        <div class="departure-luggage pt-1">
                          <h5>{{ "Departure" | translate }} - 08:35 Pm</h5>
                          <span>Ahmedabad, Airport</span>
                          <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                          <p>Saturday <span>April 23, 2023</span></p>
                          <p><span>Luggage : </span>23 kg. x2</p>
                          <p><span>Cabin Bag :</span>7 Kg</p>
                        </div>
                        <div class="arrival-class pt-1">
                          <h5>{{ "Arrival" | translate }} - 10:20 Pm</h5>
                          <span>Mumbai, Airport</span>
                          <!-- <p>Cairo, Egypt</p> -->
                          <p>Saturday <span>April 23, 2023</span></p>
                          <p><span>Trip Class : </span> Economy</p>
                        </div>
                      </div>
                      <div class="layovertime-final-flight">
                        <span>Layover : 6h 20m</span>
                      </div>
                      <div class="flight-from-to-infos d-flex align-items-start flex-wrap">
                        <div class="airline-name d-flex align-items-center airline-class-number w-100" pt-0>
                          <div class="flight-from-to-name-dtls returing-back-flight">
                            <h5>Mumbai - Ahmedabad</h5>
                          </div>
                          <div>
                            <img class="me-2" src="/assets/image/search/airline.png" width="30" height="30"
                              alt="dummy-airline" />
                            <p>
                              Egyptair MS-2633 <br />
                              BOEING - 737
                            </p>
                          </div>
                        </div>
                        <div class="departure-luggage pt-1">
                          <h5>{{ "Departure" | translate }} (BOM) - 2:35 Am</h5>
                          <span>Mumbai, Airport</span>
                          <!-- <p>Al-Qassim, Buraydah, Saudi Arabia</p> -->
                          <p><span>Saturday April 24, 2023</span></p>
                          <p><span>Luggage : </span>23 kg. x2</p>
                          <p><span>Cabin Bag :</span>7 Kg</p>
                        </div>
                        <div class="arrival-class pt-1">
                          <h5>{{ "Arrival" | translate }} (SIN) - 8:20 Am</h5>
                          <span>Changi, Singapore</span>
                          <!-- <p>Cairo, Egypt</p> -->
                          <p>Sunday <span>April 24, 2023</span></p>
                          <p><span>Trip Class : </span> Economy</p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="trip-price-infos mt-0 dsp-none" *ngIf="flightOfferDetail">
                <ul class="p-0 m-0">
                  <span class="fare-title">{{
                    "Fare Breakdown" | translate
                    }}</span>
                  <li *ngFor="let traveler of flightPriceByTraveller">
                    <a (click)="toggleTravelerPrice(traveler)">
                      {{"Traveler" | translate}} {{traveler.travelerId}} ({{traveler.travelerType | titlecase}})
                      <i class="fa-solid fa-chevron-down"></i>
                    </a>
                    <span>{{ traveler.processedPrice.currency }} {{ traveler.processedPrice.total | currency:'':''
                      }}</span>
                    <div *ngIf="traveler.showPrice" class="per-traveler-price">
                      <div>
                        <span>{{ "Fare" | translate }}</span>
                        <span>{{ traveler.processedPrice.currency }} {{ traveler.processedPrice.baseFare |
                          currency:'':'' }}</span>
                      </div>
                      <div>
                        <span tooltip="Taxes & fees include service fees, as well as third party
                        taxes and surcharges such as airport tax, fuel surcharges
                        and airline fees. For more info, please view our T&Cs &
                        FAQs." [tooltipAnimation]="true" tooltipPlacement="top">{{ "Taxes & Fees" | translate }}
                          <i class="fa-solid fa-circle-info"></i></span><span>{{ traveler.processedPrice.currency }}
                          {{traveler.processedPrice.baseFareYQ | currency:'':''}}</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <span
                      tooltip="We are constantly working on improving your booking experience and sourcing the best travel options. Our service fee helps us in providing you a seamless experience for all your travel booking needs"
                      [tooltipAnimation]="true" tooltipPlacement="top">{{ "Service Fee" | translate }}
                      <i class="fa-solid fa-circle-info"></i></span><span>{{flightOfferPriceDetail.currency}}
                      0.00</span>
                  </li>
                  <li>
                    <span tooltip="Rehlte applies VAT as per law. For more info, please
                    view our updated T&Cs & FAQs." [tooltipAnimation]="true" tooltipPlacement="top">{{ "Vat" |
                      translate }}
                      <i class="fa-solid fa-circle-info"></i></span><span>{{flightOfferPriceDetail.currency}}
                      {{flightOfferPriceDetail.baseFareYQ | currency:'':''}}</span>
                  </li>
                  <li class="final-amount-pay">
                    {{ "Total inclusive of tax" | translate }}
                    <span>{{flightOfferPriceDetail.currency}} {{flightOfferPriceDetail.total | currency:'':''}}</span>
                  </li>
                </ul>
              </div>
              <div class="login-first-tab" *ngIf="!global?.isUserLogin">
                <span><i class="fa-solid fa-circle-user"></i>
                  {{ "Login to get all of our features!" | translate }}</span>
                <a href="javascript:void(0)" (click)="openLoginModal()">{{ "Login Now" | translate }}
                  <i class="fa-solid fa-arrow-right-long"></i></a>
              </div>
              <div class="travelers-info-detls">
                <h4>{{ "Traveler Details" | translate }}</h4>
                <!-- <a href="#"><i class="fa-solid fa-plus"></i> Add Traveler</a> -->
              </div>
              <form [formGroup]="flightTraveler" class="traveler-saved-details"
                (ngSubmit)="submitTravellers()" id="travelerForm1" novalidate>
                <div formArrayName="travelersArray">
                  <div class="scrolling-main-cont">
                    <div class="traverls-list-dtls">
                      <div *ngFor="let control of travelersArray.controls; let i = index" [formGroupName]="i">
                        <div class="travelr-single-infos first-traveler-adult">
                          <div class="saved-traveler-opt" *ngIf="global?.isUserLogin">
                            <a (click)="toggleCollapse(i)">
                              {{ "Saved Travelers" | translate }}
                              <i class="fa-solid fa-chevron-down"></i>
                            </a>
                            <div class="collapse show" *ngIf="!control.get('isCollapsed')?.value">
                              <div class="card card-body border-0 saved-traveler-lists p-0">
                                <ul class="mb-0">
                                  <li *ngFor="let savedTraveler of customerTraveler">
                                    <div *ngIf="savedTraveler.type == control.get('type')?.value">
                                      <input type="radio" 
                                      id="{{'radio-' + i +'-' + savedTraveler.id}}"                                                  
                                      [value]="savedTraveler.id" formControlName="selectedTravellerID"                           
                                      [attr.disabled]="isSavedTravelerSelectedForOtherTravelers(i,savedTraveler)" 
                                      (change)="selectSavedTraveler(i, savedTraveler)" />
                                      <label 
                                      for="{{'radio-' + i +'-' + savedTraveler.id}}">
                                        {{savedTraveler.title +" " +savedTraveler.first_name +" " +savedTraveler.last_name | translate}}
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <a (click)="resetSelection(i)">{{
                                      "Reset" | translate
                                      }}</a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div action="" class="custom-radio-opt traveler-flight-name" (click)="toggleTravelerCollapse(i)">
                            <label>{{ 'Traveler' | translate }} {{ control.get('type')?.value | translate | titlecase
                              }}</label>
                          </div>
                          <div *ngIf="!control.get('isTravelerCollapsed')?.value" class="collapse show">
                            <div class="card card-body">

                              <div class="traveler-input-filds">
                                <div class="from-city-name form-input traveler-firs-name">
                                  <input formControlName="firstName" name="firstName" 
                                    type="text" placeholder="{{ 'First Name' | translate }}" required
                                    [ngClass]="{'error-input' : submitted &&  control.get('firstName')?.errors}" />
                                  <div class="name-title">
                                    <select formControlName="title" name="title" id="" >
                                      <option value="Mr">
                                        {{ "Mr" | translate }}
                                      </option>
                                      <option value="Ms">
                                        {{ "Ms." | translate }}
                                      </option>
                                      <option value="Mrs">
                                        {{ "Mrs." | translate }}
                                      </option>
                                    </select>
                                  </div>
                                  <div *ngIf="submitted && control.get('firstName')?.errors" class="input-error up-side-error">
                                    <div *ngIf="control.get('firstName')?.hasError('required')">
                                      <i class="fa-solid fa-circle-exclamation"></i> {{ 'This field is required' |
                                      translate }}.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="from-city-name form-input traveler-desig">
                                  <input type="text" formControlName="middleName" name="middleName" 
                                    placeholder="{{ 'Second Name' | translate }}" />
                                </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="from-city-name form-input traveler-desig">
                                  <input type="text" formControlName="lastName" name="lastName" 
                                    placeholder="{{ 'Last Name' | translate }}" [ngClass]="{'error-input' : submitted && control.get('lastName')?.errors}" required />
                                  <div class="input-error up-side-error" *ngIf="submitted && control.get('lastName')?.errors">
                                    <div *ngIf="control.get('lastName')?.hasError('required')">
                                      <i class="fa-solid fa-circle-exclamation"></i> {{ 'This field is required' |
                                      translate }}.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="from-city-name form-input traveler-desig">
                                  <input class="form-control" formControlName="dob" name="dob" 
                                    placeholder="{{'Date of birth' | translate}}" bsDatepicker
                                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-red' }"
                                    [maxDate]="minDate" required>
                                  <div class="input-error up-side-error" *ngIf="submitted && control.get('dob')?.errors">
                                    <div *ngIf="control.get('dob')?.hasError('required')">
                                      <i class="fa-solid fa-circle-exclamation"></i> {{ 'This field is required' |
                                      translate }}.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="custom-dropdown">
                                  Nationality
                                  <input [value]="control.get('selectedCountryNation')?.value"
                                      class="selected-input-code-filed" autocomplete="off"
                                      autocorrect="off"
                                      (click)="toggleDropdownNationality(i,$event)"
                                      autocapitalize="none" spellcheck="false" readonly />
                                  <div class="input-errormsg"
                                      *ngIf="submitted && !control.get('selectedCountryNation')?.value">
                                      <div><i class="fa-solid fa-circle-exclamation"></i>
                                        {{ 'This field is required' | translate }}.
                                      </div>
                                  </div>
                                  <div class="dropdown-content"
                                      [ngClass]="{ open: control.get('isOpenNationality')?.value}">
                                      <div class="search-via-input-code">
                                          <input class="search-dropdown_dropdown_search"
                                              type="text" placeholder="Search"
                                              formControlName="searchText"
                                              (keyup)="search('nationality',i)" />
                                      </div>
                                      <div *ngFor="let code of countryCodesNationality"
                                          (click)="toggleDropdownNationality(i,$event)">
                                          <div
                                              (click)="toggleDropdownNationality(i,$event);countryCodeSelectNationality(code,i)">
                                              <span>{{ code.country_en }}</span>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="from-city-name form-input traveler-desig">
                                  <input type="text" formControlName="number" placeholder="{{'Passport Number' | translate}}" name="number"
                                    required />
                                  <div class="input-error up-side-error" *ngIf="submitted && control.get('number')?.errors">
                                    <div *ngIf="control.get('number')?.hasError('required')">
                                      <i class="fa-solid fa-circle-exclamation"></i> {{ 'This field is required' |
                                      translate }}.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="from-city-name form-input traveler-desig">
                                  <input type="text" formControlName="birthPlace" placeholder="{{'Birth Place' | translate}}" name="birthPlace"
                                    required />
                                  <div class="input-error up-side-error" *ngIf="submitted && control.get('birthPlace')?.errors">
                                    <div *ngIf="control.get('birthPlace')?.hasError('required')">
                                      <i class="fa-solid fa-circle-exclamation"></i> {{ 'This field is required' |
                                      translate }}.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="from-city-name form-input traveler-desig">
                                  <input class="form-control" formControlName="issuanceDate" name="issuanceDate" 
                                    placeholder="{{'Issuance date' | translate}}" bsDatepicker
                                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-red' }"
                                    required>
                                  <div class="input-error up-side-error" *ngIf="submitted && control.get('issuanceDate')?.errors">
                                    <div *ngIf="control.get('issuanceDate')?.hasError('required')">
                                      <i class="fa-solid fa-circle-exclamation"></i> {{ 'This field is required' |
                                      translate }}.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="from-city-name form-input traveler-desig">
                                  <input class="form-control" formControlName="expireDate" name="expireDate"
                                    placeholder="{{'Expiry date' | translate}}" bsDatepicker
                                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-red' }"
                                    [minDate]="minDate" required>
                                  <div class="input-error up-side-error" *ngIf="submitted && control.get('expireDate')?.errors">
                                    <div *ngIf="control.get('expireDate')?.hasError('required')">
                                      <i class="fa-solid fa-circle-exclamation"></i> {{ 'This field is required' |
                                      translate }}.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="from-city-name form-input traveler-desig">
                                  <input type="text" formControlName="issuanceLocation" placeholder="{{'Issue Location' | translate}}"
                                    name="issuanceLocation" required />
                                  <div class="input-error up-side-error"
                                    *ngIf="submitted && control.get('issuanceLocation')?.errors">
                                    <div *ngIf="control.get('issuanceLocation')?.hasError('required')">
                                      <i class="fa-solid fa-circle-exclamation"></i> {{ 'This field is required' |
                                      translate }}.
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="traveler-input-filds">
                                <div class="custom-dropdown">
                                  {{"Issue Country" | translate}}
                                  <input [value]="control.get('selectedCountry')?.value"
                                      class="selected-input-code-filed" autocomplete="off"
                                      autocorrect="off"
                                      (click)="toggleDropdown(i,$event)"
                                      autocapitalize="none" spellcheck="false" readonly />
                                  <div class="input-errormsg"
                                      *ngIf="submitted && !control.get('selectedCountry')?.value">
                                      <div><i class="fa-solid fa-circle-exclamation"></i>
                                        {{ 'This field is required' | translate }}.
                                      </div>
                                  </div>
                                  <div class="dropdown-content"
                                      [ngClass]="{ open: control.get('isOpen')?.value}">
                                      <div class="search-via-input-code">
                                          <input class="search-dropdown_dropdown_search"
                                              type="text" placeholder="Search"
                                              formControlName="searchText"
                                              (keyup)="search('country',i)" />
                                      </div>
                                      <div *ngFor="let code of countryCodes"
                                          (click)="toggleDropdown(i,$event)">
                                          <div
                                              (click)="toggleDropdown(i,$event);countryCodeSelect(code,i)">
                                              <span>{{ code.country_en }}</span>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              </div>
                              <div class="frequt-traveler-info">
                                <h6>
                                  <input id="cbxFreq{{i}}" type="checkbox" class="cbx" formControlName="addFrequentFlyer" />
                                  <label for="cbxFreq{{i}}" class="lbl">{{'Add Frequent Flyer Number (Optional)' | translate}}</label>
                                </h6>
                                <div class="traveler-input-filds frequ-travel-numb" *ngIf="control.get('addFrequentFlyer')?.value">
                                  <div class="from-city-name form-input traveler-desig">
                                    <input type="text" placeholder="Freq. Number">
                                    <label for=""><img src="/assets/image/search/airline.png" alt=""></label>
                                  </div>
                                </div>
                              </div>

                              <div class="frequt-traveler-info">
                                <h6>
                                  <input id="cbxMeals{{i}}" type="checkbox" class="cbx" formControlName="addMealsAssistance"  />
                                  <label for="cbxMeals{{i}}" class="lbl">{{'Meals/Airline Assistance Service (Optional)' | translate}}</label>
                                </h6>
                                <div class="traveler-input-filds frequ-travel-meal" *ngIf="control.get('addMealsAssistance')?.value">
                                  <div class="from-city-name form-input traveler-desig">
                                    <select name="" id="">
                                      <option value="">Select Meal Type</option>
                                      <option value="">Any Meal</option>
                                      <option value="">Asian Vegeta Meal
                                      </option>
                                      <option value="">Baby Meal
                                      </option>
                                      <option value="">Bland Meal
                                      </option>
                                      <option value="">Child Meal
                                      </option>
                                      <option value="">Diabetic Meal
                                      </option>
                                      <option value="">Hindu (Non Vegetarian) Meal
                                      </option>
                                      <option value="">Low Fat Meal
                                      </option>
                                      <option value="">Low Salt Meal
                                      </option>
                                      <option value="">Muslim Meal
                                      </option>
                                    </select>
                                  </div>
                                  <div class="from-city-name form-input traveler-desig">
                                    <select name="" id="">
                                      <option value="">Select Special Services</option>
                                      <option value="">No Special Service Requested
                                      </option>
                                      <option value="">Blind Passenger
                                      </option>
                                      <option value="">Bassinet for Infant
                                      </option>
                                      <option value="">Deaf Passenger
                                      </option>
                                      <option value="">Stretcher Assistance
                                      </option>
                                      <option value="">Wheelchair - Cannot walk up stairs nor to the seat. Must be carried.
                                      </option>
                                      <option value="">Wheelchair - Can walk up stairs and to the seat
                                      </option>
                                      <option value="">Wheelchair - Cannot walk up stairs but is able to walk to the seat
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="traveling-notice-spac mt-3">
                      <p>
                        {{
                        "After completing your reservation, you can contact our customer service center to confirm the
                        addition of the frequent flyer program and special services, and also to assist you in adding
                        extra
                        baggage, or choosing a seat, and this depends on the prices and capabilities of the selected
                        airline."
                        | translate
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="continue-pay-btn">
                  <!-- Continue to seats logic without an additional button -->
                  <!-- (click)="toggleFlightSeatBooking()" -->
                  <button type="submit" (click)="submitTravellers()">
                    {{ "Continue to seats" | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- <button type="button" class="btn btn-primary">Your Trip Detail</button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!--[flightOfferPriceDetail]="flightOfferPriceDetail"-->

<app-flight-seat-booking *ngIf="showFlightSeatBooking" (skipSelection)="skipSeatSelection()"
  (goBack)="goBackFromSeatBooking()" (close)="closeSeatBooking()"></app-flight-seat-booking>

<app-flight-payment *ngIf="showFlightPayment" [searchRequestType]="searchRequestType" [oneWaySummary]="oneWaySummary"
  [travellersData]="travellersData" [flightPriceByTraveller]="flightPriceByTraveller" [selectedFlight]="selectedFlight"
  [roundTripSummary]="roundTripSummary" [multiCitySummary]="multiCitySummary" (goBack)="goBackFromPayment()"
  (close)="closePaymentBooking()"></app-flight-payment>
